<script lang="ts">
  import { type AudioTrack, type PlayerInterface } from '@foundation-player/loader';
  import { getContext } from 'svelte';
  import MenuButton from '../../shared/components/menu/MenuButton.svelte';
  import Language from '../../shared/assets/icons/Language.svelte';
  import type { FocusItem, FocusLayer } from '../../shared/focus-manager/focus-types';
  import type { PlayerStateContext } from '../../shared/types/player-state';

  export let player: PlayerInterface;
  export let focusLayer: FocusLayer;
  export let focusName: FocusItem;

  const { availableAudioTracks, activeAudioTrack } = getContext<PlayerStateContext>('playerState');

  const selectTrack = (event: CustomEvent<string>) => {
    player.setAudioTrack(event.detail);
  };

  const generateTrackLabel = (track?: AudioTrack): string => (track ? track.label || track.language : 'unbekannt');

  const formatMenuItem = (trackId: unknown) => {
    const track = $availableAudioTracks.find((track) => track.id === trackId);
    return generateTrackLabel(track);
  };
</script>

{#if $availableAudioTracks.length > 1}
  <MenuButton
    label="Sprache auswählen"
    menuItems={$availableAudioTracks.map((track) => track.id)}
    {formatMenuItem}
    selectedMenuItem={$activeAudioTrack?.id}
    on:selectItem={selectTrack}
    {focusName}
    {focusLayer}
  >
    <Language aria-hidden={true} />
  </MenuButton>
{/if}
